import { Component , ViewChild, ElementRef } from '@angular/core';
import { ChatService } from '../../../core/services/chat/chat.service';
import { DatePipe, NgClass } from '@angular/common';
import { Auth, signInWithPopup, GoogleAuthProvider, authState } from '@angular/fire/auth';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ChangeDetectorRef } from '@angular/core';
import { DataService } from '../../../core/services/data/data.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-chat',
  standalone: true,
  imports: [ RouterLink , DatePipe , ReactiveFormsModule , NgClass],
  templateUrl: './chat.component.html',
  styleUrl: './chat.component.scss'
})
export class ChatComponent {

  chatForm: FormGroup;
  messages: any[] = [];
  isLoaded = false ;
  isAuthenticated: boolean = false;
  user: any = null;
  isUserAtBottom: boolean = true;  // Track if user is at the bottom of the chat
  newMessages: boolean = false;  // To track if new messages arrived while user scrolled up

  placeholderText: string = ''; // Default placeholder (English)

  previousMessageLength: number = 0; // Variable to store the previous length of messages

  @ViewChild('messagesBox') private messagesContainer!: ElementRef;

  constructor(private chatService: ChatService, private auth: Auth , private fb: FormBuilder, private cdr: ChangeDetectorRef , private DataService : DataService) {
    // Initialize the form group
    this.chatForm = this.fb.group({
      message: ['', [Validators.required, Validators.minLength(1)]] // Add validation if needed
    });
  }

  isArabic = false ;

  changeLang () {
    if (this.DataService.isArabic) {
      this.isArabic = true ;
      this.placeholderText = 'رسالة عامة...'; // Arabic placeholder
    }
    else {
      this.isArabic = false ;
      this.placeholderText = 'Public Message...'; // English placeholder
    }
    setTimeout(() => { this.changeLang() }, 100) ;
  }

  ngOnInit(): void {
    this.changeLang() ;
    // Subscribe to authentication state changes
    authState(this.auth).subscribe((user: any) => {
      this.isAuthenticated = !!user;
      this.user = user;

      // Trigger change detection manually after sign-in
      this.cdr.detectChanges();
    });

    setInterval(() => {
      // Fetch and subscribe to chat messages
      this.chatService.getMessages().subscribe((msgs) => {
        this.previousMessageLength = this.messages.length;
        this.messages = msgs;
        this.isLoaded = true;

        // make NotificationSound when receive new message 
        if(this.messages.length > this.previousMessageLength ) {
          this.playNotificationSound();
        } 

        // If new messages have been received and the user is not at the bottom, show the notification
        if (this.messages.length > this.previousMessageLength && !this.isUserAtBottom) {
          this.newMessages = true; // Show "New messages" indicator
        }

        // Scroll to bottom only if user is at the bottom
        if (this.isUserAtBottom) {
          setTimeout(() => this.scrollToBottom(), 0);
        }
      });
    }, 2000);
  }

    // Function to handle Google Sign-In
    signInWithGoogle() {
      const provider = new GoogleAuthProvider();
      signInWithPopup(this.auth, provider)
        .then(result => {
          this.isAuthenticated = true;
          this.user = result.user;
  
          // Trigger change detection after successful sign-in
          this.cdr.detectChanges();
        })
        .catch(error => {
          console.error('Error during Google sign-in:', error);
        });
    }
  
     // Send message only if authenticated
    sendMessage() {
      if (this.chatForm.valid) {
        const userName = this.user.displayName || 'User';  // Get the user's display name
        const userPhotoURL = this.user.photoURL || '';     // Get the user's photo URL
        this.chatService.sendMessage(userName, this.chatForm.value.message,userPhotoURL);
        this.chatForm.reset(); // Clear the form after sending
        // Scroll to the bottom after sending a message
        setTimeout(() => this.scrollToBottom(), 0);
        this.newMessages = false;
      }
    } 
    

   // Scroll down to the bottom of the messages container
  scrollToBottom(): void {
    try {
      this.messagesContainer.nativeElement.scrollTop = this.messagesContainer.nativeElement.scrollHeight;
    } catch (err) {
      console.error('Scroll error:', err);
    }
  }

  onScroll(): void {
    const container = this.messagesContainer.nativeElement;
  
    // Check if the user is at the bottom of the chat
    const atBottom = container.scrollHeight - container.scrollTop <= container.clientHeight + 10;
  
    // If user is not at the bottom, show the icon
    if (!atBottom) {
      this.isUserAtBottom = false;
      document.querySelector('.toBottom')?.classList.add('show');
    } else {
      this.isUserAtBottom = true;
      document.querySelector('.toBottom')?.classList.remove('show');
    }
  }  

  playNotificationSound() {
    const audio = new Audio('assets/sounds/message-notification.mp3');
    audio.play().catch(error => {
      console.error('Failed to play notification sound:', error);
    });
  }

}
